import React, { lazy } from 'react';

const ReviewOrderComponent = lazy(
  () => import(/* webpackChunkName: "carvana-purchase-review-order" */ './review-order')
);

export const ReviewOrderRoute = () => {
  return <ReviewOrderComponent />;
};
